import {defineMessages} from 'react-intl';

const messages = defineMessages({
  day: {
    defaultMessage: 'Days',
    description: 'Interval of days',
    id: 'interval-day',
  },
  week: {
    defaultMessage: 'Weeks',
    description: 'Interval of weeks',
    id: 'interval-week',
  },
  month: {
    defaultMessage: 'Months',
    description: 'Interval of months',
    id: 'interval-month',
  },
  quarter: {
    defaultMessage: 'Quarters',
    description: 'Interval of quarters',
    id: 'interval-quarter',
  },
  year: {
    defaultMessage: 'Years',
    description: 'Interval of years',
    id: 'interval-year',
  },
  current: {
    defaultMessage: 'Current',
    description: 'Range choices from current intervals',
    id: 'range-current',
  },
  previous: {
    defaultMessage: 'Previous',
    description: 'Range choices from a previous interval',
    id: 'range-previous',
  },
  next: {
    defaultMessage: 'Next',
    description: 'Range choices from a next interval',
    id: 'range-next',
  },
  rolling: {
    defaultMessage: 'Rolling',
    description: 'Range choices from a rolling period',
    id: 'range-rolling',
  },
  periodToDate: {
    defaultMessage: 'Period To Date',
    description: 'Range choices from a period up to current date',
    id: 'range-period-to-date',
  },
  other: {
    defaultMessage: 'Other',
    description: 'Range choices different not fitting a category',
    id: 'range-other',
  },
  today: {
    defaultMessage: 'Today',
    description: 'Data from today',
    id: 'range-today',
  },
  thisWeek: {
    defaultMessage: 'This Week',
    description: 'Data from this week',
    id: 'range-this-week',
  },
  thisMonth: {
    defaultMessage: 'This Month',
    description: 'Data from this month',
    id: 'range-this-month',
  },
  thisQuarter: {
    defaultMessage: 'This Quarter',
    description: 'Data from this quarter',
    id: 'range-this-quarter',
  },
  thisYear: {
    defaultMessage: 'This Year',
    description: 'Data from this year',
    id: 'range-this-year',
  },
  yesterday: {
    defaultMessage: 'Yesterday',
    description: 'Data from the previous day',
    id: 'range-yesterday',
  },
  lastWeek: {
    defaultMessage: 'Last Week',
    description: 'Data from the previous week',
    id: 'range-last-week',
  },
  lastMonth: {
    defaultMessage: 'Last Month',
    description: 'Data from the previous month',
    id: 'range-last-month',
  },
  lastQuarter: {
    defaultMessage: 'Last Quarter',
    description: 'Data from the previous quarter',
    id: 'range-last-quarter',
  },
  lastYear: {
    defaultMessage: 'Last Year',
    description: 'Data from the previous year',
    id: 'range-last-year',
  },
  tomorrow: {
    defaultMessage: 'Tomorrow',
    description: 'Data from the tomorrow',
    id: 'range-tomorrow',
  },
  nextWeek: {
    defaultMessage: 'Next Week',
    description: 'Data from the next week',
    id: 'range-next-week',
  },
  nextMonth: {
    defaultMessage: 'Next Month',
    description: 'Data from the next month',
    id: 'range-next-month',
  },
  nextQuarter: {
    defaultMessage: 'Next Quarter',
    description: 'Data from the next quarter',
    id: 'range-next-quarter',
  },
  nextYear: {
    defaultMessage: 'Next Year',
    description: 'Data from the next year',
    id: 'range-next-year',
  },
  lastSevenDays: {
    defaultMessage: 'Last 7 Days',
    description: 'Data within the past 7 days',
    id: 'range-last-seven-days',
  },
  lastThirtyDays: {
    defaultMessage: 'Last 30 Days',
    description: 'Data within the past 30 days',
    id: 'range-last-thirty-days',
  },
  lastThreeMonths: {
    defaultMessage: 'Last 3 Months',
    description: 'Data within the past 3 months',
    id: 'range-last-three-months',
  },
  lastSixMonths: {
    defaultMessage: 'Last 6 Months',
    description: 'Data within the past 6 months',
    id: 'range-last-six-months',
  },
  lastTwelveMonths: {
    defaultMessage: 'Last 12 Months',
    description: 'Data within the past twelve months',
    id: 'range-last-twelve-months',
  },
  last: {
    defaultMessage: 'Last...',
    description: 'Data within a custom interval',
    id: 'range-last-custom',
  },
  weekToDate: {
    defaultMessage: 'Week to Date',
    description: 'Data starting this week',
    id: 'range-week-to-date',
  },
  monthToDate: {
    defaultMessage: 'Month to Date',
    description: 'Data starting this month',
    id: 'range-month-to-date',
  },
  quarterToDate: {
    defaultMessage: 'Quarter to Date',
    description: 'Data starting this quarter',
    id: 'range-quarter-to-date',
  },
  yearToDate: {
    defaultMessage: 'Year to Date',
    description: 'Data starting this year',
    id: 'range-year-to-date',
  },
  between: {
    defaultMessage: 'Between',
    description: 'Data between two dates',
    id: 'range-between',
  },
  allTime: {
    defaultMessage: 'All Time',
    description: 'Data from all time',
    id: 'range-all-time',
  },
});

export const RANGE_TYPES = {
  PRESET: 'PRESET',
  INTERVAL: 'INTERVAL',
  FIXED: 'FIXED',
};

export const RANGE_INTERVALS = [
  {key: 'DAY', label: messages.day},
  {key: 'WEEK', label: messages.week},
  {key: 'MONTH', label: messages.month},
  {key: 'QUARTER', label: messages.quarter},
  {key: 'YEAR', label: messages.year},
];

export const RANGE_GROUPS = {
  CURRENT: {key: 'CURRENT', ...messages.current},
  PREVIOUS: {key: 'PREVIOUS', ...messages.previous},
  NEXT: {key: 'NEXT', ...messages.next},
  ROLLING: {key: 'ROLLING', ...messages.rolling},
  PERIOD_TO_DATE: {key: 'PERIOD_TO_DATE', ...messages.periodToDate},
  OTHER: {key: 'OTHER', ...messages.other},
};

export const RANGE_OPTIONS = [
  {
    key: 'TODAY',
    group: RANGE_GROUPS.CURRENT,
    label: messages.today,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'DAY',
      offset: 0,
    },
  },
  {
    key: 'THIS_WEEK',
    group: RANGE_GROUPS.CURRENT,
    label: messages.thisWeek,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'WEEK',
      offset: 0,
    },
  },
  {
    key: 'THIS_MONTH',
    group: RANGE_GROUPS.CURRENT,
    label: messages.thisMonth,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'MONTH',
      offset: 0,
    },
  },
  {
    key: 'THIS_QUARTER',
    group: RANGE_GROUPS.CURRENT,
    label: messages.thisQuarter,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'QUARTER',
      offset: 0,
    },
  },
  {
    key: 'THIS_YEAR',
    group: RANGE_GROUPS.CURRENT,
    label: messages.thisYear,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'YEAR',
      offset: 0,
    },
  },
  {
    key: 'YESTERDAY',
    group: RANGE_GROUPS.PREVIOUS,
    label: messages.yesterday,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'DAY',
      offset: 1,
    },
  },
  {
    key: 'LAST_WEEK',
    group: RANGE_GROUPS.PREVIOUS,
    label: messages.lastWeek,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'WEEK',
      offset: 1,
    },
  },
  {
    key: 'LAST_MONTH',
    group: RANGE_GROUPS.PREVIOUS,
    label: messages.lastMonth,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'MONTH',
      offset: 1,
    },
  },
  {
    key: 'LAST_QUARTER',
    group: RANGE_GROUPS.PREVIOUS,
    label: messages.lastQuarter,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'QUARTER',
      offset: 1,
    },
  },
  {
    key: 'LAST_YEAR',
    group: RANGE_GROUPS.PREVIOUS,
    label: messages.lastYear,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'YEAR',
      offset: 1,
    },
  },
  {
    key: 'TOMORROW',
    group: RANGE_GROUPS.NEXT,
    label: messages.tomorrow,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'DAY',
      offset: -1,
    },
  },
  {
    key: 'NEXT_WEEK',
    group: RANGE_GROUPS.NEXT,
    label: messages.nextWeek,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'WEEK',
      offset: -1,
    },
  },
  {
    key: 'NEXT_MONTH',
    group: RANGE_GROUPS.NEXT,
    label: messages.nextMonth,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'MONTH',
      offset: -1,
    },
  },
  {
    key: 'NEXT_QUARTER',
    group: RANGE_GROUPS.NEXT,
    label: messages.nextQuarter,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'QUARTER',
      offset: -1,
    },
  },
  {
    key: 'NEXT_YEAR',
    group: RANGE_GROUPS.NEXT,
    label: messages.nextYear,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'INTERVAL_OFFSET',
      interval: 'YEAR',
      offset: -1,
    },
  },
  {
    key: 'LAST_SEVEN_DAYS',
    group: RANGE_GROUPS.ROLLING,
    label: messages.lastSevenDays,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'ROLLING_PERIOD',
      interval: 'DAY',
      count: 7,
      offset: 0,
    },
  },
  {
    key: 'LAST_THIRTY_DAYS',
    group: RANGE_GROUPS.ROLLING,
    label: messages.lastThirtyDays,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'ROLLING_PERIOD',
      interval: 'DAY',
      count: 30,
      offset: 0,
    },
  },
  {
    key: 'LAST_THREE_MONTHS',
    group: RANGE_GROUPS.ROLLING,
    label: messages.lastThreeMonths,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'ROLLING_PERIOD',
      interval: 'MONTH',
      count: 3,
      offset: 0,
    },
  },
  {
    key: 'LAST_SIX_MONTHS',
    group: RANGE_GROUPS.ROLLING,
    label: messages.lastSixMonths,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'ROLLING_PERIOD',
      interval: 'MONTH',
      count: 6,
      offset: 0,
    },
  },
  {
    key: 'LAST_TWELVE_MONTHS',
    group: RANGE_GROUPS.ROLLING,
    label: messages.lastTwelveMonths,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {
      dateTimeRangeType: 'ROLLING_PERIOD',
      interval: 'MONTH',
      count: 12,
      offset: 0,
    },
  },
  {
    key: 'LAST',
    group: RANGE_GROUPS.ROLLING,
    label: messages.last,
    type: RANGE_TYPES.INTERVAL,
    dateTimeRange: {dateTimeRangeType: 'ROLLING_PERIOD', interval: 'DAY'},
  },
  {
    key: 'WEEK_TO_DATE',
    group: RANGE_GROUPS.PERIOD_TO_DATE,
    label: messages.weekToDate,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {dateTimeRangeType: 'PERIOD_TO_DATE', interval: 'WEEK'},
  },
  {
    key: 'MONTH_TO_DATE',
    group: RANGE_GROUPS.PERIOD_TO_DATE,
    label: messages.monthToDate,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {dateTimeRangeType: 'PERIOD_TO_DATE', interval: 'MONTH'},
  },
  {
    key: 'QUARTER_TO_DATE',
    group: RANGE_GROUPS.PERIOD_TO_DATE,
    label: messages.quarterToDate,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {dateTimeRangeType: 'PERIOD_TO_DATE', interval: 'QUARTER'},
  },
  {
    key: 'YEAR_TO_DATE',
    group: RANGE_GROUPS.PERIOD_TO_DATE,
    label: messages.yearToDate,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: {dateTimeRangeType: 'PERIOD_TO_DATE', interval: 'YEAR'},
  },
  {
    key: 'BETWEEN',
    group: RANGE_GROUPS.OTHER,
    label: messages.between,
    type: RANGE_TYPES.FIXED,
    dateTimeRange: {dateTimeRangeType: 'FIXED_RANGE'},
  },
  {
    key: 'ALL_TIME',
    group: RANGE_GROUPS.OTHER,
    label: messages.allTime,
    type: RANGE_TYPES.PRESET,
    dateTimeRange: null,
  },
];

RANGE_OPTIONS.forEach((choice, index) => (choice.index = index));

export const RANGE_OPTIONS_KEYED = RANGE_OPTIONS.reduce((memo, opt) => {
  memo[opt.key] = opt;
  return memo;
}, {});

export const RANGE_DEFAULT_COUNT = 3;
export const RANGE_DEFAULT_INTERVAL = 'DAY';
export const RANGE_DEFAULT_OPTION = RANGE_OPTIONS_KEYED.ALL_TIME;
